import React from 'react';

const StatsCard = ({ title, value, icon, color }) => (
  <div className="bg-white rounded-lg shadow p-6">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm font-medium text-gray-600">{title}</p>
        <p className="text-2xl font-bold text-gray-900">{value}</p>
      </div>
      <div className={`p-3 rounded-full ${
        color === 'blue' ? 'bg-blue-100' :
        color === 'green' ? 'bg-green-100' :
        color === 'purple' ? 'bg-purple-100' : 'bg-yellow-100'
      }`}>
        <span className="text-xl">{icon}</span>
      </div>
    </div>
  </div>
);

export default StatsCard;
